/**
 * /frontend/src/features/analytics/components/anomalies/AnomalyTimeline.js
 */

import React from 'react';
import './AnomalyTimeline.css';

/**
 * Renders anomaly timeline list.
 * @param {{items:Array<any>}} props
 * @returns {JSX.Element}
 */
const AnomalyTimeline = ({ items }) => (
  <div className="analytics-anomaly-timeline">
    <div className="analytics-anomaly-timeline-head">
      <div>Type</div>
      <div>Severity</div>
      <div>Affected</div>
      <div>Triggered</div>
    </div>
    {(items || []).map((item) => (
      <div key={`${item.type}-${item.triggeredAt}-${item.affectedEntity || ''}`} className="analytics-anomaly-timeline-row">
        <div className="mono">{item.type}</div>
        <div>{item.severity}</div>
        <div className="mono">{item.affectedEntity || '-'}</div>
        <div className="mono">{item.triggeredAt || '-'}</div>
      </div>
    ))}
  </div>
);

export default AnomalyTimeline;

